import {useMutation, useQuery} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { showHttpErrorToast } from '@common/utils/http/show-http-error-toast';



const endpoint = (id: number|string) => `loan-products/${id}/loan-program-download-md`;

interface Response extends BackendResponse {}

interface Payload {
  id: number|string;
}

export function useDownloadMdLoanProgram() {
  return useMutation({
    mutationFn: (payload: Payload) => fetchMdLoanProgram(payload),
    onError: err => showHttpErrorToast(err),
  });
}

function fetchMdLoanProgram({id}: Payload): Promise<Response> {
  return apiClient.post(endpoint(id), {}, {responseType: 'blob'}).then(r => r.data);
}
